var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPause = function SvgPause(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 19q-.825 0-1.412-.587A1.93 1.93 0 0 1 14 17V7q0-.824.588-1.412A1.93 1.93 0 0 1 16 5q.824 0 1.413.588Q18 6.175 18 7v10q0 .824-.587 1.413A1.93 1.93 0 0 1 16 19m-8 0q-.824 0-1.412-.587A1.93 1.93 0 0 1 6 17V7q0-.824.588-1.412A1.93 1.93 0 0 1 8 5q.825 0 1.412.588Q10 6.175 10 7v10q0 .824-.588 1.413A1.93 1.93 0 0 1 8 19"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPause);
export { ForwardRef as ReactComponent };